<template>
  <div
    class="ApplicationBanner"
    :class="{
      'ApplicationBanner--training': isTraining,
      'ApplicationBanner--welcome': isWelcomeView
    }"
  >
    <b-container>
      <b-row>
        <b-col class="headline">
          <div class="bannerTitle">
            <div v-html="content"></div>
          </div>

          <div class="bgLeftElement"></div>
          <div class="bgRightElement"></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'ApplicationBanner',
  props: ['content'],
  computed: {
    isTraining() {
      return this.$store.state.inTrainingMode
    },
    isWelcomeView() {
      return this.$route.name === 'WelcomeView'
    }
  }
}
</script>

<style lang="scss">
.ApplicationBanner {
  position: relative;
  padding: 30px;
  h1 {
    display: inline;
    a {
      color: white;
      text-decoration: none;
      &:hover {
        text-decoration: none;
        color: $color-focus;
      }
      &:focus {
        color: white;
      }
    }
  }
}

@include mobile {
  #app .ApplicationBanner.ApplicationBanner--training {
    top: $header-height-training-small;
    &.ApplicationBanner--welcome {
      top: $header-height-training-large;
    }
  }
}
</style>
